import { Routes, Route } from "react-router-dom";
import React from "react";

import "./assets/style.css";

// import Home from "./pages/home.js";
// import OldStart from "./pages/old_start";
import Finish from "./pages/finish";
// import Redirect from "./pages/redirect";
import Packages from "./pages/packages";

function App() {
  return (
    <Routes>
      <Route path="/" element={<Packages />} />
      <Route path="/:month" element={<Packages />} />
      <Route path="/experiencia/:id" element={<Packages />} />
      {/* 
      <Route path="/reservar" element={<Home />} />
      <Route path="/reservar/start" element={<OldStart />} />
      <Route path="/reservar/end" element={<Finish />} />
      <Route path="/reservar/experiencias" element={<OldStart />} /> 
      */}
      <Route path="/reservar/end" element={<Finish />} />
      <Route path="*" element={<Packages />} />
    </Routes>
  );
}

export default App;
